import React, { useEffect, useState } from 'react';
import QuoteModal from '../../common/modals/quote-modal';
import ImageWithBasePath from '../../../../core/img/ImageWithBasePath';
import BecomeProvider from '../../common/modals/provider-modal';
import { Link } from 'react-router-dom';
import { all_routes } from '../../../../core/data/routes/all_routes';
import FeatureSection from './feature-section';
import PopularSection from './popular-section';
import WorkSection from './workSection';
import PreferredSection from './preferredSection';
import ProviderSection from './provider-section';
import RateServiceSection from './rateServiceSection';
import CustomerSection from './customerSection';
// import BlogAndJoinus from './blogAndJoinus';
// import BussinessWithUs from './bussinessWithUs';
// import ServiceCities from './serviceCities';
import HomeHeader from '../header/home-header';
import NewFooter from '../footer/newFooter';
import AuthModals from './authModals';
import { db, auth } from '../../../../firebase';
import { useAuthState } from "react-firebase-hooks/auth";
import { getDocs, collection, query, limit } from 'firebase/firestore';
import { Spin } from 'antd';
import { useNavigate } from "react-router-dom";
import BlogAndJoinus from './blogAndJoinus';
import BussinessWithUs from './bussinessWithUs';
import { Color } from 'antd/es/color-picker';
import PopupModal from '../../common/modals/popup'; // adjust path if needed
import TermsCondition from '../../pages/terms-condition/terms-condition';



const NewHome = () => {
  const routes = all_routes;
  const navigate = useNavigate();

  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);


  // Fetch services from Firestore
  const fetchServices = async () => {
    setLoading(true);
    try {
      const collectionName = user ? 'services' : 'service_duplicate';
      const q = query(collection(db, collectionName), limit(12));
      const snapshot = await getDocs(q);
      const servicesList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setServices(servicesList);
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoading(false);
    }
  };



  // useEffect(() => {
  //   fetchServices();
  // }, []);

  const handleServiceClick = (service) => {
    console.log("Navigating to:", routes.techcategories);
    navigate(routes.techcategories, {
      state: { service }, // Passing the entire service object
    });
  };



  // authenticate user /login 
  const [user, authLoading] = useAuthState(auth);


  // useEffect(() => {
  //   if (!authLoading && !user) {
  //     navigate(all_routes.index, { replace: true });
  //   }
  // }, [user, authLoading, navigate]);

  // Redirect to login if user is not authenticated
  useEffect(() => {
    if (!authLoading) {
      fetchServices();
    }
  }, [user, authLoading]);

  // ✅ Logout function to clear local storage and sign out from Firebase
  // const handleLogout = async () => {
  //   try {
  //     await signOut(auth); // Firebase logout
  //     console.log("Logout successful.");
  //   } catch (error) {
  //     console.error("Logout failed:", error);
  //   } finally {
  //     localStorage.clear(); // Clears all local storage
  //     navigate(routes.index, { replace: true }); // Redirect to home or login page
  //   }
  // };


  return (
    <>
      <HomeHeader type={user ? 11 : 1} />
      {/* <HomeHeader type={1} /> */}
      {/* {user ? <HomeHeader type={1} /> : <HomeHeader type={11} />} */}
      <>
        {/* Hero Section */}
        <section className="hero-section" id="home"
          style={{
            backgroundImage: `url("https://i.postimg.cc/mZ5fxsvz/bg.jpg")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}>
          <div className="hero-content position-relative overflow-hidden">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div
                    className="wow fadeInUp"
                    data-wow-duration="1s"
                    data-wow-delay=".25s"
                  >
                    <h1 className="mb-2" style={{ color: '#fff' }}>
                      Connect with Nearby Top-rated{" "}
                      <span className="text-linear-primary" data-type-text="Carpenters" style={{ color: '#fff' }}>Professionals</span>
                    </h1>
                    <p className="mb-3 sub-title" style={{ color: '#fff' }}>
                      We can connect you to the right Services, first time and every
                      time.
                    </p>
                    <div className="banner-form border mb-3"
                      style={{
                        background: "rgba(255, 255, 255, 0.2)",
                        borderRadius: "10px",
                        backdropFilter: "blur(10px)",
                        WebkitBackdropFilter: "blur(10px)",
                        padding: "10px",
                        border: "none",
                      }}>
                      <form action="#">
                        <div className="d-md-flex align-items-center">
                          <div className="input-group mb-2">
                            <span className="input-group-text px-1">
                              <i className="ti ti-search" style={{ color: "#A020F0", fontSize: "1.2rem" }} />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search for Service"
                              style={{ backgroundColor: '#FFFFFF00', color: '#fff' }}
                            />
                          </div>
                          <div className="input-group mb-2">
                            <span className="input-group-text px-1">
                              <i className="ti ti-map-pin" style={{ color: "#A020F0", fontSize: "1.2rem" }} />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Location"
                              style={{ backgroundColor: '#FFFFFF00', color: '#fff' }}
                            />
                          </div>
                          <div className="mb-2">
                            <Link to={routes.search} className="btn btn-linear-primary d-inline-flex align-items-center w-100">
                              <i className="feather icon-search me-2" style={{ color: "#fff", fontSize: "1.2rem" }}></i>
                              Search
                            </Link>
                          </div>
                        </div>
                      </form>
                      <ImageWithBasePath
                        src="assets/img/bg/bg-06.svg"
                        alt="img"
                        className="shape-06 round-animate"
                      />
                    </div>

                    <div className="d-flex align-items-center flex-wrap">
                      <h6 className="mb-2 me-2 fw-medium" style={{ color: '#fff' }}>Popular Searches</h6>
                      <Link
                        to={routes.search}
                        className="badge badge-dark-transparent fs-14 fw-normal mb-2 me-2"
                      >
                        Plumber
                      </Link>
                      <Link
                        to={routes.search}
                        className="badge badge-dark-transparent fs-14 fw-normal mb-2 me-2"
                      >
                        Interior
                      </Link>
                      <Link
                        to={routes.search}
                        className="badge badge-dark-transparent fs-14 fw-normal mb-2 me-2"
                      >
                        Nail Technicians
                      </Link>
                    </div>
                    <div className="d-flex align-items-center flex-wrap banner-info">
                      <div className="d-flex align-items-center me-4 mt-4">
                        <img src="assets/img/icons/success-01.svg" alt="icon" style={{ filter: 'invert(1) sepia(1) saturate(5) hue-rotate(180deg)' }} />
                        <div className="ms-2">
                          <h6 style={{ color: '#fff' }}>215,292 +</h6>
                          <p style={{ color: '#fff' }}>Verified Providers</p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center me-4 mt-4">
                        <img src="assets/img/icons/success-02.svg" alt="icon" style={{ filter: 'invert(1) sepia(1) saturate(5) hue-rotate(180deg)' }} />
                        <div className="ms-2">
                          <h6 style={{ color: '#fff' }}>90,000+</h6>
                          <p style={{ color: '#fff' }}>Services Completed</p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center me-4 mt-4">
                        <img src="assets/img/icons/success-03.svg" alt="icon" style={{ filter: 'invert(1) sepia(1) saturate(5) hue-rotate(180deg)' }} />
                        <div className="ms-2">
                          <h6 style={{ color: '#fff' }}>2,390,968 </h6>
                          <p style={{ color: '#fff' }}>Reviews Globally</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="banner-img wow fadeInUp"
                  data-wow-duration="1s"
                  data-wow-delay=".25s"
                >
                  <ImageWithBasePath
                    // src="assets/img/banner.png"
                    src="assets/img/IMG_18.png"
                    alt="img"
                    className="img-fluid animation-float"
                  />
                </div>
              </div>
            </div>
            <div className="hero-image">
              <div className="d-inline-flex bg-trans p-2 rounded align-items-center shape-01 floating-x">
                <span className="avatar avatar-md bg-warning rounded-circle me-2">
                  <i className="ti ti-star-filled" />
                </span>
                <span>
                  4.9 / 5<small className="d-block">(255 reviews)</small>
                </span>
                <i className="border-edge" />
              </div>
              <div className="d-inline-flex bg-trans p-2 rounded align-items-center shape-02 floating-x">
                <span className="me-2">
                  <ImageWithBasePath src="assets/img/icons/tick-banner.svg" alt="" />
                </span>
                <span style={{ fontSize: '13.5px' }}>300 Booking Completed</span>
                <i className="border-edge" />
              </div>
              <ImageWithBasePath src="assets/img/bg/bg-03.svg" alt="img" className="shape-03" />
              <ImageWithBasePath src="assets/img/bg/bg-04.svg" alt="img" className="shape-04" />
              <ImageWithBasePath src="assets/img/bg/bg-05.svg" alt="img" className="shape-05" />
            </div>
          </div>
        </section>
        {/* /Hero Section */}
        {/* Category Section */}
        <section className="section category-section" style={{
          backgroundImage: `url("https://i.postimg.cc/mZ5fxsvz/bg.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 text-center wow fadeInUp" data-wow-delay="0.2s">
                <div className="section-header text-center">
                  <h2 className="mb-1" style={{ color: '#fff' }}>
                    Explore our <span className="text-linear-primary">Services</span>
                  </h2>
                  <p className="sub-title" style={{ color: '#fff' }}>
                    Service categories help organize and structure the offerings on a marketplace, making it easier for users to find what they need.
                  </p>
                </div>
              </div>
            </div>

            <div className="row g-4 justify-content-center">
              {loading ? (
                <div className="row g-4 justify-content-center">
                  <div className="col">
                    <div className="category-item text-center wow fadeInUp" data-wow-delay="0.2s">
                      <Spin />
                    </div>
                  </div>
                </div>
              ) : (
                services.map((service) => (
                  <div className="col-6 col-sm-6 col-md-4 col-lg-3" key={service.id} onClick={() => handleServiceClick(service)}>
                    <div className="category-item text-center wow fadeInUp" data-wow-delay="0.2s">
                      <div className="mx-auto mb-3">
                        <img
                          className="card-img-top"
                          src={service.icon || 'placeholder-image-path.jpg'}
                          alt={service.lbl || 'Untitled Category'}
                          style={{
                            width: '75px',
                            height: '75px',
                          }}
                        />
                      </div>
                      <h6 className="fs-14 mb-1" style={{ color: '#fff' }}>{service.lbl || 'Untitled Category'}</h6>
                    </div>
                  </div>
                ))
              )}
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="text-center view-all wow fadeInUp" data-wow-delay="0.2s">
                  <Link to={routes.techservices} className="btn btn-dark">
                    View All
                    <i className="ti ti-arrow-right ms-2" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* /Category Section */}
        {/* <LocationSection/> */}
        <FeatureSection />
        <PopularSection />
        <WorkSection />
        {/* <PreferredSection /> */}
        {/* <ProviderSection /> */}
        <RateServiceSection />
        {/* <CustomerSection /> */}
        {/* <BlogAndJoinus/> */}
        <BussinessWithUs />

        <NewFooter />
      </>
      <PopupModal/>
      <AuthModals />
      <QuoteModal />
      <BecomeProvider />
    </>
  )
}

export default NewHome